import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { version } from '../package.json';

console.log(`App version:${version} - build type:${process.env.NODE_ENV}`);

var constants = {
  LOG_ENABLED: true
};
window.constants = constants;

// log = (function() {
//   var context = "Apolhygie:";
//
//   return Function.prototype.bind.call(console.log, console, context);
// })();
//log("This is a test...", {"Hello":"World"});

if (process.env.NODE_ENV !== 'development') {
  constants.LOG_ENABLED = false;
}

var old = console.log;
// console.log = function() {
//   if (constants.LOG_ENABLED) {
//     old.apply(console, arguments);
//   }
// };

console.log = (function() {
  if (constants.LOG_ENABLED) {
    const context = 'Apolhygie:';
    return Function.prototype.bind.call(old, console, context);
  } else {
    return () => {};
  }
})();
// console.log("This is a test...", { Hello: "World" }, { Hello: "World2" });

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js